import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#202137", // Customize primary color
    },
    secondary: {
      main: "#e3f2fd", // Customize secondary color
    },
  },
});
